import {
  canManageDashboards
} from '../middleware/middleware';


import DashboardProfileEdit from '../../components/dashboards/pages/DashboardProfileEdit';
import DashboardProfileList from '../../components/dashboards/pages/DashboardProfileList';

export default [
  { path: '/blade/dashboards/profiles', component: DashboardProfileList, beforeEnter: canManageDashboards },
  { path: '/blade/dashboards/profiles/create', component: DashboardProfileEdit, beforeEnter: canManageDashboards },
  { path: '/blade/dashboards/profiles/:profileId/edit', component: DashboardProfileEdit, beforeEnter: canManageDashboards }
];



// WEBPACK FOOTER //
// ./src/router/dashboards/routes.js